import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllEarningSlice = createSlice({
  name: "getAllEarning",
  initialState: { data: null, pagination: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data.data;
      state.pagination = action.payload.pagination;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllEarningSlice;
const getAllEarningAction = createAction(name);

export {
  getAllEarningAction,
  actions as getAllEarningActions,
  reducer as getAllEarningReducer,
};
